import { AsyncThunkConfigWithRejectValue, createAsyncThunk } from '@/redux/createAsyncThunk';
import {
    CatalogFeaturedLotsInfo,
    SaveFeaturedLotsByCatalogIdParams,
    SuggestedFeaturedLot,
} from '@/redux/modules/featuredLots/featuredLots.types';
import { getAuthToken } from '@/redux/modules/user';
import { getDeployment } from '@/redux/modules/config';
import {
    getFeaturedLotsByCatalogId,
    getSuggestedFeaturedLots,
    postFeaturedLotsByCatalogId,
} from '@/redux/modules/featuredLots/featuredLots.api';
import { getFeaturedLotsRequestErrorMessage } from '@/redux/modules/featuredLots/featuredLots.utils';

export const fetchFeaturedLotsByCatalogId = createAsyncThunk<
    CatalogFeaturedLotsInfo,
    number,
    AsyncThunkConfigWithRejectValue
>('la/ui/featuredLots/fetchFeaturedLotsByCatalogId', async (catalogId, { getState, rejectWithValue }) => {
    const state = getState();
    const authToken = getAuthToken(state);
    const deployment = getDeployment(state);
    try {
        const response = await getFeaturedLotsByCatalogId({
            authToken,
            catalogId,
            deployment,
        });
        return response.payload;
    } catch (error) {
        return getFeaturedLotsRequestErrorMessage(error, rejectWithValue);
    }
});

export const saveFeaturedLotsByCatalogId = createAsyncThunk<
    string[],
    SaveFeaturedLotsByCatalogIdParams,
    AsyncThunkConfigWithRejectValue
>(
    'la/ui/featuredLots/saveFeaturedLotsByCatalogId',
    async ({ catalogId, lotNumbers }, { getState, rejectWithValue }) => {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);
        try {
            const response = await postFeaturedLotsByCatalogId({
                authToken,
                catalogId,
                deployment,
                lotNumbers,
            });
            return response.payload.featuredLots;
        } catch (error) {
            return getFeaturedLotsRequestErrorMessage(error, rejectWithValue);
        }
    }
);

export const fetchSuggestedFeaturedLots = createAsyncThunk<SuggestedFeaturedLot[], number>(
    'la/ui/featuredLots/fetchSuggestedFeaturedLots',
    async (catalogId, { getState }) => {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);
        const response = await getSuggestedFeaturedLots({
            authToken,
            catalogId,
            deployment,
        });
        return response.data;
    }
);
